module.exports = __webpack_public_path__ + "img/13d.25e37951.svg";